type NamedContact = { first_name?: string | null; last_name?: string | null };
type PhoneContact = { phone_number?: string | null; phone_number_extension?: string | null };

/** "Last, First" for lists; falls back to whichever part exists. */
export const formatContactSortName = (contact: NamedContact): string =>
  [contact.last_name, contact.first_name].filter(Boolean).join(', ') || '--';

/** "First Last" for headings. */
export const formatContactName = (contact: NamedContact): string =>
  [contact.first_name, contact.last_name].filter(Boolean).join(' ') || '--';

export const formatContactPhone = (contact: PhoneContact): string => {
  if (!contact.phone_number) return '';
  return contact.phone_number_extension
    ? `${contact.phone_number} x${contact.phone_number_extension}`
    : contact.phone_number;
};

export const pluralize = (count: number, singular: string, plural = `${singular}s`) =>
  `${count} ${count === 1 ? singular : plural}`;

/** Secondary line for a contact in pickers: email, then phone. */
export const contactDisplayDetail = (contact: { email?: string | null } & PhoneContact): string =>
  [contact.email, formatContactPhone(contact)].filter(Boolean).join(' · ');
